import { styled } from "@mui/material";

import { ButtonBasic } from "@/Components/v2/atoms/Button/ButtonBasic";

export const StyledHendrenButton = styled(ButtonBasic)(({ theme }) => ({
  fontSize: "14px",
  borderRadius: theme.spacing(1.5),
  border: `1px solid #E7E7E7`,
}));
